import { forwardRef, type Ref, type SVGProps } from "react";
const IconRotateCounterClockwiseFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M15.556 3.653a.966.966 0 1 0-1.366-1.366l-2.629 2.629a.96.96 0 0 0-.282.715.97.97 0 0 0 .282.719l2.63 2.629a.966.966 0 0 0 1.365-1.366l-1.04-1.041 5.913.017a6.34 6.34 0 0 1 6.322 6.322l.024 8.136a.966.966 0 1 0 1.932-.005l-.024-8.137a8.273 8.273 0 0 0-8.249-8.248L14.57 4.64z"
    />
    <path
      fill="currentColor"
      d="M4.94 12.093c-.91 0-1.647.738-1.647 1.648v14.607c0 .91.738 1.648 1.648 1.648h14.607c.91 0 1.648-.738 1.648-1.648V13.741c0-.91-.738-1.648-1.648-1.648z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRotateCounterClockwiseFilledSVG);
ForwardRef.displayName = "IconRotateCounterClockwiseFilled";
export { ForwardRef as IconRotateCounterClockwiseFilled };
